import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo';
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import Icon from '@/components/Icon';
import * as utils from '@/utils';
export default tsx.componentFactoryOf().create({
    name: 'description-popover',
    props: {
        description: p.ofType().default(undefined),
        spanTitle: p.ofType().default('Click to show help'),
        triggers: p.ofType().default(() => ['click', 'blur']),
        show: p(Boolean).default(false),
        hugText: p(Boolean).default(false),
        title: p.ofType().default(undefined),
        placement: p.ofType().default('right'),
        icon: p.ofType().default(() => faInfo),
        boundary: p.ofType().default(undefined),
        scale: p(Number).default(0.75),
        width: p.ofType().default(undefined),
        docsPath: p(String).default(''),
        extraPopoverClass: p(String).optional,
        stopPropagation: p(Boolean).default(false),
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data() {
        return {
            id: `description-popover-${utils.getUniqueId()}`,
        };
    },
    computed: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        popoverClass() {
            let base;
            if (this.width == null) {
                base = 'description-popover-root';
            }
            else {
                base = 'description-popover-root-custom-width';
            }
            if (this.extraPopoverClass == null) {
                return base;
            }
            return `${base} ${this.extraPopoverClass}`;
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        wrapperClass() {
            const wrapperClass = ['description-popover', 'd-inline-block', 'cursor-help'];
            if (!this.hugText) {
                wrapperClass.push('float-right');
            }
            return wrapperClass;
        },
    },
    methods: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        async focusDescription() {
            this.$withRef('description', ref => {
                if (ref instanceof HTMLElement) {
                    ref.focus();
                }
            });
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        popoverContent(h) {
            return (<div ref="description" tabindex={-1} class="description-popover-content text-justify" style={{
                    width: this.width,
                    hyphens: 'auto',
                    outline: 'none !important',
                }}>
                    {utils.ifExpr(this.description != null, () => this.description, () => {
                    if (this.$scopedSlots.description != null) {
                        return this.$scopedSlots.description();
                    }
                    else {
                        return this.$scopedSlots.default?.();
                    }
                })}

                    {utils.ifOrEmpty(this.docsPath !== '', () => (<div class="mt-2">
                            See{' '}
                            <a href={`https://help.codegrade.com/${this.docsPath}`} target="_blank">
                                our documentation
                            </a>{' '}
                            for more details.
                        </div>))}
                </div>);
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        onPropagation(ev) {
            if (this.stopPropagation) {
                ev.stopImmediatePropagation();
                ev.preventDefault();
            }
        },
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h) {
        const onPropagation = this.onPropagation.bind(this);
        return (
        // TODO: Do we really need all these wrapping spans? I think we did
        // that because the spanTitle wasn't showing up correctly. Is this
        // still the case?
        <span class={this.wrapperClass} onClick={tsx.modifiers.stop.prevent} onPointerdown={onPropagation} onMousedown={onPropagation} onTouchstart={onPropagation} onFocus={onPropagation} onFocusout={onPropagation}>
                {/* Some element in the popover must be focused for the blur trigger to work. */}
                {/* https://github.com/bootstrap-vue/bootstrap-vue/issues/4548 --> */}
                <b-popover onShown={this.focusDescription} placement={this.placement} triggers={this.triggers} show={this.show} target={this.id} boundary={this.boundary} title={this.title} customClass={this.popoverClass} style={{ maxWidth: this.width == null ? '' : 'calc(100vw - 1rem)' }}>
                    {this.popoverContent(h)}
                </b-popover>

                <span id={this.id} class="desc-pop-span d-inline-block h-100">
                    {h(this.hugText ? 'sup' : 'span', {
                attrs: { title: this.spanTitle },
                class: 'px-1',
            }, [
                this.icon === faInfo ? (<Icon icon={this.icon} scale={this.scale} scaleX={this.scale * 1.3}/>) : (<Icon icon={this.icon} scale={this.scale}/>),
            ])}
                </span>
            </span>);
    },
});
